import $ from "jquery";
import { onFailure } from "./api";

export function sendForm(
	data,
	dataMapper,
	endpoint,
	successHandler,
	failureHandler,
) {
	const newData = JSON.stringify(dataMapper(data));

	$.ajax({
		type: "POST",
		url: endpoint,
		data: newData,
		contentType: "application/json; charset=utf-8",
		dataType: "json",
	})
		.done(successHandler)
		.fail(onFailure(failureHandler, "Failed to send form."));
}
